import { withTranslation } from '@application/i18n/with_translation';
import { ActionCard, Flex, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { useState } from 'react';
import {
	clearStoredSessionId,
	connectCareCompanion,
	getStoredSessionId,
	isSessionNotFound,
	storeSessionId,
} from './care_companion_client';

interface CareCompanionLaunchProps {
	licenceHolderId: number;
	isAuthenticated: boolean;
	onClick?: () => void;
	onNavigate: (route: string) => void;
	onSignIn?: () => void;
}

export function CareCompanionLaunch({
	licenceHolderId,
	isAuthenticated,
	onClick,
	onNavigate,
	onSignIn,
}: CareCompanionLaunchProps): JSX.Element {
	const [isStarting, setIsStarting] = useState(false);
	const [hasError, setHasError] = useState(false);
	const storedSessionId = getStoredSessionId(licenceHolderId);

	async function startChat(): Promise<void> {
		setIsStarting(true);
		setHasError(false);

		try {
			let sessionId = getStoredSessionId(licenceHolderId);

			if (sessionId != null) {
				try {
					const connection = await connectCareCompanion(sessionId);
					sessionId = connection.sessionId;
				} catch (error) {
					if (!isSessionNotFound(error)) throw error;

					clearStoredSessionId(licenceHolderId);
					sessionId = null;
				}
			}

			if (sessionId == null) {
				const connection = await connectCareCompanion();
				sessionId = connection.sessionId;
			}

			storeSessionId(licenceHolderId, sessionId);
			onNavigate(`/care-companion/${sessionId}`);
		} catch {
			setHasError(true);
		} finally {
			setIsStarting(false);
		}
	}

	return (
		<Flex gap={tokens.spacing.x1}>
			<ActionCard.Root icon='speechBubbleDots' disabled={isStarting} onClick={isAuthenticated ? startChat : (onSignIn ?? onClick)}>
				<ActionCard.Title>
					{withTranslation(
						!isAuthenticated || storedSessionId == null ? 'CareCompanion.Launch.Title' : 'CareCompanion.Launch.ResumeTitle',
					)}
				</ActionCard.Title>
				<ActionCard.Meta>{withTranslation('CareCompanion.Launch.Description')}</ActionCard.Meta>
			</ActionCard.Root>
			{hasError ? <Text variant='bodySmallRegular'>{withTranslation('CareCompanion.Chat.Error')}</Text> : null}
		</Flex>
	);
}
